import React from "react";

import { encodeSearchTerms } from "@cayuse/shared-react.utils.helpers";
import { executeRequest } from "@cayuse/shared-react.utils.http";
import _ from "lodash";

import { API_UNIT } from "globals/constants";

import { spUrl, escapeForElasticSearchQuery } from "./helpers";


export const searchUnits = searchText => {
	const searchTerms = [
		{ key: "name", val: `${escapeForElasticSearchQuery(searchText.toLocaleLowerCase()).trim()}` },
		{ key: "active", val: true }
	];

	const search = encodeSearchTerms(searchTerms);

	const url = spUrl(`${API_UNIT}?search=${search}`);

	return executeRequest(url)
		.then(response => {
			const options = _.uniqBy(response.content ?? [], "id").map(unit => {
				return {
					key: unit.id,
					value: unit.id,
					text: unit.name,
					unit: unit,
					content: (
						<div className="optionContent">
							<span>{unit.name}</span>
						</div>
					),
				};
			});

			return { options, hiddenOptionsCount: response.totalPages > 1 && response.totalElements - response.content.length };
		});
};
